import { StateCreator } from 'zustand';
import { RootState } from '../rootStore.ts';

export const AUTH = 'AUTH';

export interface LoadingSlice {
  isLoading: boolean;
  loadingOperations: Record<string, boolean>;
  loadingMessages: Record<string, string>;
  startLoading: (operationId?: string, message?: string) => void;
  stopLoading: (operationId?: string) => void;
  isOperationLoading: (operationId: string) => boolean;
  getLoadingMessage: () => string | null;
}

export const createLoadingSlice: StateCreator<RootState, [], [], LoadingSlice> = (set, get) => ({
  isLoading: false,
  loadingOperations: {},
  loadingMessages: {},

  startLoading: (operationId = AUTH, message = '') =>
    set((state) => ({
      loadingOperations: {
        ...state.loadingOperations,
        [operationId]: true,
      },
      loadingMessages: message
        ? {
            ...state.loadingMessages,
            [operationId]: message,
          }
        : state.loadingMessages,
      isLoading: true,
    })),

  stopLoading: (operationId = AUTH) =>
    set((state) => {
      const { [operationId]: _, ...remainingOperations } = state.loadingOperations;
      const { [operationId]: __, ...remainingMessages } = state.loadingMessages;

      return {
        loadingOperations: remainingOperations,
        loadingMessages: remainingMessages,
        isLoading: Object.keys(remainingOperations).length > 0,
      };
    }),

  isOperationLoading: (operationId) => {
    return get().loadingOperations[operationId] || false;
  },

  getLoadingMessage: () => {
    const { loadingOperations, loadingMessages } = get();
    const operationIds = Object.keys(loadingOperations);
    if (operationIds.length === 0) return null;

    const firstOperation = operationIds[0];
    return loadingMessages[firstOperation] || 'Loading...';
  },
});
